import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import {getAccount} from "./accountApi";
import {Status} from "../../infrastructure/status";
import {type WithState} from "../../store/utils";

export interface AccountState {
  name: string;
  status: Status;
}

const initialState: AccountState = {
  name: "",
  status: Status.IDLE
};

export const getAccountAsync = createAsyncThunk(
  "account/getAccount",
  async (_, {fulfillWithValue, rejectWithValue}) => {
    try {
      const response = await getAccount();
      return fulfillWithValue(response.data);
    } catch (err) {
      rejectWithValue({});
    }
  }
);

export const accountSlice = createSlice({
  name: "account",
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getAccountAsync.pending, state => {
        state.status = Status.LOADING;
      })
      .addCase(getAccountAsync.fulfilled, (state, action) => {
        state.status = Status.IDLE;
        state.name = action.payload?.data?.name;
      })
      .addCase(getAccountAsync.rejected, state => {
        state.status = Status.FAILED;
      });
  }
});

export const selectAccountName = (state: WithState<AccountState, "account">) => state.account.name;
export const selectAccountStatus = (state: WithState<AccountState, "account">) => {
  return state.account.status;
};

export const accountReducer = accountSlice.reducer;
